var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1774_7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7299 8.85817L9.96738 1.09969L9.44707 0.579375C9.32852 0.461605 9.16819 0.395508 9.00109 0.395508C8.83398 0.395508 8.67366 0.461605 8.55511 0.579375L0.272293 8.85817C0.150815 8.97917 0.0548095 9.12329 -0.0100575 9.28201C-0.0749246 9.44072 -0.107338 9.61083 -0.105385 9.78228C-0.0973498 10.4894 0.491266 11.0539 1.19841 11.0539H2.0522V17.597H15.95V11.0539H16.8218C17.1654 11.0539 17.4888 10.9193 17.7319 10.6763C17.8516 10.5569 17.9464 10.4151 18.0109 10.2589C18.0754 10.1027 18.1082 9.9352 18.1076 9.76621C18.1076 9.42469 17.973 9.10125 17.7299 8.85817ZM10.1261 16.1506H7.87609V12.0524H10.1261V16.1506ZM14.5035 9.6075V16.1506H11.4118V11.5702C11.4118 11.1263 11.0522 10.7667 10.6082 10.7667H7.39394C6.94997 10.7667 6.59037 11.1263 6.59037 11.5702V16.1506H3.49863V9.6075H1.57006L9.0031 2.18049L9.46716 2.64455L16.4341 9.6075H14.5035Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1774_7402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Home.5f699f05.svg";
export { ForwardRef as ReactComponent };